import { Nullable } from '@/Types';
import { BinaryResponse } from '@/Api';
import { PrintUnionDocumentRequest } from '@/Api/DocumentTemplates/Requests/PrintUnionDocumentRequest';

export enum PrinterScale {
  NoScale = 'noscale',
  Shrink = 'shrink',
  Fit = 'fit',
}

export enum PrintResult {
  None,
  ErrorDownloading,
  ErrorSaving,
  ErrorPrint,
  Success,
}

export enum PaperKind {
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  A5 = 'A5',
  A6 = 'A6',
  Letter = 'letter',
  Legal = 'legal',
  Tabloid = 'tabloid',
  Statement = 'statement',
}

export type PrinterSettings = {
  printerName: string;
  isPreview: boolean;
};

export type TemplateSettings = {
  isSaveWhenPrinting: boolean;
  directoryPath: string;
  orientation?: string;
  scale?: string;
  silent?: boolean;
};

export interface IPrintService {
  getPrinters: () => IPrinterInfo[];
  getDefaultPrinter: () => Nullable<IPrinterInfo>;
  printHandler: (
    request: PrintUnionDocumentRequest,
    templateGuid: string,
    callback?: (params: number[]) => void,
  ) => Promise<PrintResult>;
  printDocument: (file: BinaryResponse, templateGuid: string) => Promise<PrintResult>;
  printLabel: (file: string, isPrintPreview: boolean, assignPrinter: string) => Promise<PrintResult>;
}

export interface IPrinterInfo {
  description: string;
  /**
   * the name of the printer as shown in Print Preview.
   */
  displayName: string;
  /**
   * whether or not a given printer is set as the default printer on the OS.
   */
  isDefault: boolean;
  /**
   * the name of the printer as understood by the OS.
   */
  name: string;
  /**
   * an object containing a variable number of platform-specific printer information.
   */
  options: object;
  /**
   * the current status of the printer.
   */
  status: number;
}
